import { Card, CardContent, Divider, Stack, Typography } from '@mui/material'
import React from 'react'

type RenderMonthProps = {
    month: string,
    count?: number,
    monthNumber: number,
    onMonthClicked: (month: number) => void
}

function RenderMonth({ onMonthClicked,count = 0, month, monthNumber }: RenderMonthProps) {
    return (
        <Card sx={{ width: '100%', cursor: 'pointer' }} onClick={() => onMonthClicked(monthNumber)}>
            <CardContent>
                <Stack spacing={2}>

                    <Typography textAlign={'center'} variant='subtitle2'>{month}</Typography>
                    <Divider></Divider>
                    <Typography textAlign={'center'} variant='h6'>{count}</Typography>

                </Stack>
            </CardContent>
        </Card>
    )
}

export default RenderMonth